export const ISSUE_TEMPLATE_FIELD_TITLE = 'title';
export const ISSUE_TEMPLATE_FIELD_ADDED_BY = 'addedBy';
export const ISSUE_TEMPLATE_FIELD_CREATED = 'createdAt';
export const ISSUE_TEMPLATE_FIELD_ISSUE_TYPE = 'issueType';
export const ISSUE_TEMPLATE_FIELD_ISSUE_SUBTYPE = 'issueSubtype';
export const ISSUE_TEMPLATE_FIELD_SEVERITY = 'severity';
export const ISSUE_TEMPLATE_FIELD_IS_AUTOMATIC = 'isAutomatic';

export type IssueTemplateFieldNameType =
  | typeof ISSUE_TEMPLATE_FIELD_TITLE
  | typeof ISSUE_TEMPLATE_FIELD_ADDED_BY
  | typeof ISSUE_TEMPLATE_FIELD_CREATED
  | typeof ISSUE_TEMPLATE_FIELD_ISSUE_TYPE
  | typeof ISSUE_TEMPLATE_FIELD_ISSUE_SUBTYPE
  | typeof ISSUE_TEMPLATE_FIELD_SEVERITY
  | typeof ISSUE_TEMPLATE_FIELD_IS_AUTOMATIC;

export const ISSUE_TEMPLATES_GRID_KEY = 'issue-templates-grid';
